import { HttpError } from '../../../src/business/httpError';
import { AxiosError } from 'axios';
import { portal } from '../../assets/plugins/axios/axios';
import { FullEventModel } from '../../models/fullEvent.model';
import { RespondToSimpleEventRequest } from '../../models/requests/respondToSimpleEvent.request';
import { RespondToTimeSlotEventRequest } from '../../models/requests/respondToTimeSlotEvent.request';
import { UpdateResponseToTimeSlotEventRequest } from '../../models/requests/updateResponseToTimeSlotEvent.request';
import { BlockTimeSlotRequest } from '../../models/requests/blockTimeSlot.request';
import { RemoveBlockingOrResponseToTimeSlotRequest } from '../../models/requests/removeBlockingOrResponseToTimeSlot.request';

class CalendarService {
  public getEventById = async (eventId: number, occurrenceDateTime: string = null): Promise<FullEventModel> => {
    try {
      const { data } = await portal.get('?method=calendar.getEventById', {
        params: { eventId, occurrenceDateTime },
      });
      return data.data;
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };

  public respondToSimpleEvent = async (payload: RespondToSimpleEventRequest) => {
    try {
      await portal.post('?method=calendar.respondToSimpleEvent', payload);
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };

  public deleteEvent = async (payload: { id: number; occurrenceDateTime?: string }) => {
    try {
      await portal.post('?method=calendar.deleteEvent', payload);
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };

  public respondToTimeSlotEvent = async (payload: RespondToTimeSlotEventRequest) => {
    try {
      await portal.post('?method=calendar.respondToTimeSlotEvent', payload);
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };

  public updateResponseToTimeSlotEvent = async (payload: UpdateResponseToTimeSlotEventRequest) => {
    try {
      await portal.post('?method=calendar.updateResponseToTimeSlotEvent', payload);
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };

  public blockTimeSlot = async (payload: BlockTimeSlotRequest) => {
    try {
      await portal.post('?method=calendar.blockTimeSlot', payload);
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };

  public removeBlockingOrResponseToTimeSlot = async (payload: RemoveBlockingOrResponseToTimeSlotRequest) => {
    try {
      await portal.post('?method=calendar.removeBlockingOrResponseToTimeSlot', payload);
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };

  public getTimeSlotResponse = async (eventId: number, concerningInstProfileId: number) => {
    try {
      const { data } = await portal.get('?method=calendar.getTimeSlotResponse', {
        params: { eventId, concerningInstProfileId },
      });
      return data.data;
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };
}

export const calendarService = new CalendarService();
